import { createFileRoute } from '@tanstack/react-router';

import { BankCreditRequestSection } from '~/features/leadDetails/components/BankCreditRequest';

export const Route = createFileRoute('/_app/leads_/details/$leadId/bank-request')({
    component: BankCreditRequestSection,
});
